window.addEventListener("load", function() {
  
  gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

  let mm = gsap.matchMedia();
  
// Toggle mobile navigation menu
  const hamburgerMenuButton = document.querySelector('.js-menu-button');
  const hamburgerMenuOverlay = document.querySelector('.js-hamburger-menu-overlay');

  // Add event listener to toggle the menu
  hamburgerMenuButton.addEventListener('click', function () {
    hamburgerMenuOverlay.classList.toggle('is-open');
    document.body.classList.toggle('menu-open'); // To prevent scrolling when the menu is open
  });

  // Optional: Close the menu when clicking outside or pressing ESC key
  document.addEventListener('click', function (event) {
    if (!hamburgerMenuOverlay.contains(event.target) && !hamburgerMenuButton.contains(event.target)) {
      hamburgerMenuOverlay.classList.remove('is-open');
      document.body.classList.remove('menu-open');
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      hamburgerMenuOverlay.classList.remove('is-open');
      document.body.classList.remove('menu-open');
    }
  });

});